import React, { useRef, useState, useEffect, useCallback } from 'react';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { useTranslation } from 'react-i18next';

import mapboxgl from 'mapbox-gl';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

import { getHeight } from 'rsuite/esm/DOMHelper';
import { Button, ButtonGroup, Col, Panel, Row, Stack } from 'rsuite';

// import * as data from './data.json';
// import * as dataTravelers from './dataTravelers.json';
// import * as dataToSay from './dataToSay.json';
// import * as dataHeadcount from './dataHeadcount.json';
import { format } from 'date-fns';
import { useAppSelector } from '@/config/hooks';

mapboxgl.accessToken =
  'pk.eyJ1IjoicmF3ZW5tZXJzYW5pIiwiYSI6ImNsNmF6ejFsYTBtZXYzanFmcXp6MHJoZnUifQ.w144brpzhoKqRv9MODG5rQ';

const MapClusters = props => {
  // const { data } = props;

  const missions = useAppSelector(state => state.dashboard.data);
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [zoom] = useState(0);
  const [center, setCenter] = useState([0, 0]);
  const geocoder = useRef(null);

  const [jsonData, setJsonData] = React.useState({});
  const [type, setType] = React.useState('');
  const [mapStyle, setMapStyle] = useState(
    localStorage.getItem('theme') != null && localStorage.getItem('theme') == 'dark'
      ? 'mapbox://styles/mapbox/dark-v11'
      : 'mapbox://styles/mapbox/light-v11'
  );

  React.useEffect(() => {

    let filteredMissions = [];

    switch (type) {
      case 'departure':
        filteredMissions = missions.filter(mission => mission.missionTag === 'departure');
        break;
      case 'ongoing':
        filteredMissions = missions.filter(mission => mission.missionTag === 'ongoing');
        break;
      case 'returning':
        filteredMissions = missions.filter(mission => mission.missionTag === 'returning');
        break;
      case 'departure_and_return':
        filteredMissions = missions.filter(
          mission => mission.missionTag === 'departure_and_return'
        );
        break;
      default:
        filteredMissions = missions;
    }

    // const features = filteredMissions.map(mission => ({
    //   type: 'Feature',
    //   properties: {
    //     ...mission,
    //     id: mission._id
    //   },
    //   geometry: {
    //     type: 'Point',
    //     coordinates: [...mission.country?.coordinates[1], ...mission.country?.coordinates[0], 0.0]
    //   }
    // }));

    const invalidMissions = filteredMissions.filter(
      mission => !mission.country || !Array.isArray(mission.country.coordinates)
    );
    const features = filteredMissions.flatMap(mission => {
      // if (mission.missionType === 'compound') {
      //   return mission.missions.map(compoundMission => ({
      //     type: 'Feature',
      //     properties: {
      //       ...mission,
      //       ...compoundMission,
      //       id: compoundMission._id
      //     },
      //     geometry: {
      //       type: 'Point',
      //       coordinates: [
      //         ...compoundMission.country?.coordinates[1],
      //         ...compoundMission.country?.coordinates[0],
      //         0.0
      //       ]
      //     }
      //   }));
      // } else {

      if (!mission.country || !Array.isArray(mission.country.coordinates)) {
        return [];
      }
      return {
        type: 'Feature',
        properties: {
          ...mission,
          id: mission._id
        },
        geometry: {
          type: 'Point',
          coordinates: [mission.country?.coordinates[1], mission.country?.coordinates[0], 0.0]
        }
      };
      // }
    });

    const json = {
      type: 'FeatureCollection',
      crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
      features: features
    };

    setJsonData(json);
  }, [type, missions]);

  useEffect(() => {

    // if (map.current) return;
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: mapStyle,
      zoom: 2,
      center: [0, 20],
      projection: 'mercator'
    });
    map.current.addControl(new mapboxgl.NavigationControl());

    geocoder.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: ('Search'),
      marker: false,
      width: '200px',
      types: 'country,region,place,postcode,locality,neighborhood,poi'
    });

    // map.current.addControl(geocoder.current);
    map.current.addControl(new mapboxgl.FullscreenControl());
    map.current.on('load', () => {
      addSource();

      map.current.on('click', 'clusters', e => {
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        const clusterId = features[0].properties.cluster_id;
        map.current.getSource('my-data').getClusterExpansionZoom(clusterId, (err, zoom) => {
          if (err) return;

          map.current.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        });
      });

      // map.current.on('click', 'unclustered-point', e => {
      //   console.log('eeeeeeeeeeeeeeeee', e);
      //   const coordinates = e.features[0].geometry.coordinates.slice();
      //   const properties = e.features[0].properties;
      //   const country = JSON.parse(e.features[0].properties?.country);
      //   const city = e.features[0].properties?.city
      //     ? JSON.parse(e.features[0].properties?.city)
      //     : '';

      //   // Ensure that if the map is zoomed out such that
      //   // multiple copies of the feature are visible, the
      //   // popup appears over the copy being pointed to.
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   }

      //   new mapboxgl.Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(
      //       `<p class="subtitle">${
      //         properties?.firstname + ' ' + properties?.lastname
      //       }<br>From <b>${format(
      //         new Date(properties?.startDate),
      //         'dd-MM-yyyy'
      //       )}</b> To <b>${format(new Date(properties?.endDate), 'dd-MM-yyyy')}</b><br>${
      //         country?.name + ', ' + city?.name
      //       }</p>`
      //     )
      //     .addTo(map.current);
      // });

      map.current.on('click', 'unclustered-point', e => {
        // Récupérer toutes les fonctionnalités au point cliqué
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ['unclustered-point']
        });

        if (!features.length) return;

        const coordinates = features[0].geometry.coordinates.slice();
        let popupContent = '<div style="max-height: 200px; overflow-y: auto;">';

        // Regrouper les informations des fonctionnalités
        features.forEach(feature => {
          const properties = feature.properties;
          const country = JSON.parse(properties?.country);
          const city = properties?.city ? JSON.parse(properties?.city) : '';

          popupContent += `
            <p class="subtitle" style="margin: 0; padding: 5px 0; border-bottom: 1px solid #ddd;">
              ${properties?.firstname + ' ' + properties?.lastname}<br>
              From <b>${format(new Date(properties?.startDate), 'dd-MM-yyyy')}</b> To <b>${format(
            new Date(properties?.endDate),
            'dd-MM-yyyy'
          )}</b><br>
              ${country?.name + (city ? ', ' + city?.name : '')}
            </p>
          `;
        });

        popupContent += '</div>';

        // Corriger les coordonnées si nécessaire
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // Afficher un seul popup avec le contenu combiné et scrollable
        new mapboxgl.Popup({ maxWidth: '300px' }) // Ajoute une largeur maximale
          .setLngLat(coordinates)
          .setHTML(popupContent)
          .addTo(map.current);
      });

      map.current.on('mouseenter', 'clusters', () => {
        map.current.getCanvas().style.cursor = 'pointer';
      });
      map.current.on('mouseleave', 'clusters', () => {
        map.current.getCanvas().style.cursor = '';
      });
    });
  }, [mapStyle]);

  useEffect(() => {
    if (map.current && jsonData) {
      map.current.getSource('my-data')?.setData(jsonData);
    }
  }, [jsonData]);

  // console.log('jsonData', jsonData);

  const addSource = () => {
    if (map.current.getSource('my-data')) {
      map.current.removeLayer('unclustered-point');
      map.current.removeLayer('clusters');
      map.current.removeSource('my-data');
    }
    map.current.addSource('my-data', {
      type: 'geojson',
      // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
      // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
      // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
      data: jsonData,
      cluster: true,
      clusterMaxZoom: 14, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    });

    map.current.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'my-data',
      filter: ['has', 'point_count'],
      paint: {
        // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
        // with three steps to implement three types of circles:
        //   * Blue, 20px circles when point count is less than 100
        //   * Yellow, 30px circles when point count is between 100 and 750
        //   * Pink, 40px circles when point count is greater than or equal to 750
        'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40]
      }
    });

    map.current.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'my-data',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
      }
    });

    map.current.addLayer({
      id: 'unclustered-point',
      type: 'circle',
      source: 'my-data',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': '#11b4da',
        'circle-radius': 5,
        'circle-stroke-width': 1,
        'circle-stroke-color': '#fff'
      }
    });
  };

  // useEffect(() => {
  //   const myButton = document.getElementById('themeButton');
  //   myButton?.addEventListener('click', function () {
  //     const theme = localStorage.getItem('theme');
  //     map.current.getSource('my-data')?.setData(jsonData);

  //     setTimeout(async () => {
  //       const theme = localStorage.getItem('theme');
  //       if (theme == 'dark') {
  //         setMapStyle('mapbox://styles/mapbox/dark-v11');
  //         // await map.current.setStyle('mapbox://styles/mapbox/dark-v11');
  //       } else {
  //         setMapStyle('mapbox://styles/mapbox/light-v11');

  //         // await map.current.setStyle('mapbox://styles/mapbox/light-v11');
  //       }

  //       // // map.current.getSource('my-data')?.setData(jsonData);
  //       // console.log('jsonData after 10ms', jsonData);
  //       // // console.log('maaaaaaaaaaaap', map.current);
  //       // const data = await map.current.getSource('my-data')._data;
  //       // await map.current.getSource('my-data')?.setData(data);
  //       // console.log('datadata', data);
  //     }, 10);
  //   });

  //   // return () => {
  //   //   myButton.removeEventListener('click');
  //   // };
  // }, []);
  const { t } = useTranslation();

  return (
    <div className="mt-20">
      {' '}
      <Panel
        // className="card"
        header={
          <Stack justifyContent="space-between">
            {t('Global Distribution of Business Travel')}
            <ButtonGroup>
              <Button
                active={type == 'departure'}
                onClick={() => {
                  setType('departure');
                }}
              >
                {t('Departure')}
              </Button>
              <Button
                active={type == 'ongoing'}
                onClick={() => {
                  setType('ongoing');
                }}
              >
                {t('Ongoing')}
              </Button>
              <Button
                active={type == 'returning'}
                onClick={() => {
                  setType('returning');
                }}
              >
                {t('Returns')}
              </Button>
              <Button
                active={type == 'departure_and_return'}
                onClick={() => {
                  setType('departure_and_return');
                }}
              >
                {t('Departure-Return')}
              </Button>
            </ButtonGroup>
          </Stack>
        }
      >
        <div
          ref={mapContainer}
          style={{ height: Math.max(getHeight(window) - 150, 400), width: '100%' }}
          // style={{ height: '900px', width: '100%' }}
        />
      </Panel>
    </div>
  );
};

export default MapClusters;
